import { createContext, useContext } from "react"

export const LocaleConfigContext = createContext({})
const { Provider } = LocaleConfigContext

export const LocaleConfigProvider = Provider

export function useLocaleConfig() {
  const localeConfig = useContext(LocaleConfigContext)
  return localeConfig
}
